import React, { FC } from "react"
import { Container } from "../Container"
import { HeroProps } from "./Hero.types"

import "./Hero.scss"
import HeroTag from "./HeroTag"
import House from "./House"

const Hero: FC<HeroProps> = ({
    children,
    className,
    sub,
    image,
    tags,
    ...htmlProps
}: HeroProps) => {
    let klass = "zb-hero"
    klass += ` ${className || ""}`
    klass += sub ? " zb-sub" : ""

    return (
        <div className={klass} {...htmlProps}>
            {!sub && (
                <svg
                    className="zb-hero-background"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 100 100"
                    height="100%"
                    width="100%"
                    preserveAspectRatio="none"
                >
                    <path d="M0,0 V20 c0,0 50,170 100,0 V0 H0" />
                </svg>
            )}
            <Container>
                {tags && (
                    <div className="zb-hero-tags">
                        {tags.map((t, i) => (
                            <HeroTag key={i} {...t} />
                        ))}
                    </div>
                )}
                <div className="zb-hero-body">
                    <div className="zb-hero-left">{children}</div>
                    {image && <div className="zb-hero-image">{image}</div>}
                </div>
            </Container>
        </div>
    )
}

Hero.defaultProps = {
    image: House,
}

export default Hero
